module.exports = __webpack_public_path__ + "img/gas-pump-slash.d738e2d0.svg";